import React from "react";
import Modal from "../../../../components/admin/shared/Modal";
import { XIcon } from "./icons/XIcon";

const NebulaModal = ({
  open,
  onClose,
  title,
  titleIcon,
  description,
  size = "sm",
  align = "start",
  classNames = {},
  footer,
  stickyHeader = false,
  children,
}) => {
  const { root = "", header = "", body = "" } = classNames;
  const isCenterVertical = align === "center-vertical";
  const isHeaderless = align === "none";
  const isFloatingClose = isCenterVertical || isHeaderless;

  const closeButton = (
    <button
      type="button"
      onClick={onClose}
      className={`w-[32px] h-[32px] rounded-full border border-[#ececed] bg-white flex items-center justify-center text-[#3c3c43] hover:bg-gray-50 transition-colors shrink-0 ${
        isFloatingClose ? "absolute right-[16px] top-[16px]" : ""
      }`}
    >
      <XIcon className="w-[16px] h-[16px]" />
    </button>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      size={size}
      centered
      className={`!rounded-[16px] ${root}`}
    >
      <div
        className={`pt-[20px] pb-[32px] px-[24px] flex flex-col ${
          stickyHeader ? "h-full min-h-0" : body
        }`}
      >
        {isFloatingClose && closeButton}

        {isCenterVertical && (
          <div className={`flex flex-col items-center text-center ${header}`}>
            {titleIcon}
            <h2 className="mt-[8px] text-[24px] font-[700] text-[#111827] leading-[32px]">
              {title}
            </h2>
            {description && (
              <p className="mt-[8px] text-[16px] leading-[24px] text-[#636369]">
                {description}
              </p>
            )}
          </div>
        )}

        {!isFloatingClose && (
          <div
            className={`flex justify-between gap-[16px] ${
              align === "center" ? "items-center" : "items-start"
            } ${header}`}
          >
            {titleIcon && (
              <div className="flex items-start gap-[12px] min-w-0">
                {titleIcon}
                <h2 className="text-[20px] font-[700] text-[#111827] leading-[32px]">
                  {title}
                </h2>
              </div>
            )}
            {!titleIcon && (
              <h2 className="text-[20px] font-[700] text-[#111827] leading-[32px]">
                {title}
              </h2>
            )}
            {closeButton}
          </div>
        )}

        {stickyHeader ? <div className={body}>{children}</div> : children}

        {footer}
      </div>
    </Modal>
  );
};

export default NebulaModal;
